import React from "react";
import { useSelector } from "react-redux";

import FiltrationTag from "../../../components/FiltrationTag/FiltrationTag";
import useSearchParamsState from "../../../../../hooks/useSearchParamsState";

const Filter = () => {
	const meterTypes = useSelector((store) => store.meterStore.meterTypes);
	const tags = useSelector((store) => store.meterStore?.tags);
	const [activeTypes, setActiveTypes] = useSearchParamsState(
		"types",
		[],
		(arr) => arr?.map(Number)
	);
	const [activeTags, setActiveTags] = useSearchParamsState("tags", [], (arr) =>
		arr?.map(Number)
	);
	if (!meterTypes?.length) {
		return null;
	}
	return (
		<>
			{meterTypes?.map((type) => {
				return (
					<FiltrationTag
						className={`filtration-tag
								${activeTypes?.includes(type.id) ? "filtration-tag-active" : ""}`}
						type={type}
						key={type.id}
						active={activeTypes?.includes(type?.id)}
						onDelete={() =>
							setActiveTypes(
								activeTypes?.filter((typeId) => {
									return typeId !== type?.id;
								})
							)
						}
						onAdd={() => setActiveTypes([...activeTypes, type?.id])}
					/>
				);
			})}
			{tags?.map((tag) => {
				return (
					<FiltrationTag
						className={`filtration-tag
								${activeTags?.includes(tag.id) ? "filtration-tag-active" : ""}`}
						type={tag}
						key={tag.id}
						active={activeTags?.includes(tag.id)}
						onDelete={() =>
							setActiveTags(
								activeTags?.filter((tagId) => {
									return tagId !== tag?.id;
								})
							)
						}
						onAdd={() => setActiveTags([...activeTags, tag.id])}
					/>
				);
			})}
		</>
	);
};

export default Filter;
